import styled from 'styled-components';

export const ContentOutdateVersion = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`